<template>
    <div>
        <!-- 官方流程更改 -->
        <step-component id="official-step-1"
            class="f-topic-official-more-operation"
            :label="'问题分类'">
            <step-question slot="expand"
                ref="question"
                @after="afterConfirmQuestionCategory"
                @clear="hasClearIssue"></step-question>
        </step-component>

        <!-- 关联issue -->
        <step-component :label="'设置issue关联'"
            v-if="canSetRelatedIssue && !isClosed"
            id="official-step-2"
            class="f-topic-official-more-issue">
            <step-set-issue slot="expand"
                ref="officialIssue"
                :related-issue-type="'official'"
                @openwindow="openConfirmWindow"
                @resetreply="resetReply"></step-set-issue>
        </step-component>

        <!-- 回复话术提交 -->
        <step-component v-if="canSetAnswerReply"
            id="official-step-3"
            class="f-topic-official-more-answer"
            :label="'结论'">
            <step-answer-reply slot="expand"
                ref="answer"></step-answer-reply>
        </step-component>

        <!-- 提交审核 -->
        <step-component v-if="canSubmitAudit"
            class="f-topic-official-more-submit"
            id="official-audit"
            :label="'审核分配'">
            <step-submit-audit slot="expand"
                @submit="submitToAudit"></step-submit-audit>
        </step-component>

        <!-- 审核 -->
        <step-component v-if="canAudit"
            class="f-topic-official-more-audit"
            :label="'信息审核'">
            <step-audit slot="expand"
                @openwindow="openConfirmWindow"></step-audit>
        </step-component>

        <!-- 已关闭状态的关联issue -->
        <step-component :label="'设置issue关联'"
            v-if="isClosed && canOperateOfficial"
            class="f-topic-official-more-issue">
            <step-set-issue slot="expand"
                :related-issue-type="'topic'"
                @openwindow="openConfirmWindow"></step-set-issue>
        </step-component>

        <!-- 通用信息确认弹窗 -->
        <veui-confirm-box
            v-if="infoOpen"
            :open.sync="infoOpen"
            @ok="ok"
            @cancel="cancel"
        >
            <p>{{infoTip}}</p>
        </veui-confirm-box>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
import {mapState, mapGetters} from 'vuex';
import {ConfirmBox} from 'veui';
import Step from './Step.vue';
import QuestionJudge from './QuestionJudge.vue';
import SetRelatedIssue from './SetRelatedIssue.vue';
import AnswerReply from './AnswerReply.vue';
import SubmitAudit from './SubmitAudit.vue';
import Audit from './Audit.vue';

import {throttle, debounce} from '@/utils/debounceThrottle';
import toast from 'veui/managers/toast';
import {notAllowScroll, allowScroll, scrollToId} from '@/utils/decorate/scroll';

export default {
    data() {
        return {
            infoOpen: false,
            infoTip: '',
            operationType: '',
            infoOkQuery: {}
        };
    },
    components: {
        'step-component': Step,
        'step-question': QuestionJudge,
        'step-set-issue': SetRelatedIssue,
        'step-answer-reply': AnswerReply,
        'step-submit-audit': SubmitAudit,
        'step-audit': Audit,
        'veui-confirm-box': ConfirmBox
    },
    computed: {
        ...mapState({
            showTips: state => state.topicContent.showTips,
            officialinfo: state => state.topicContent.topicData.ext.qaOfficialInfo
        }),
        ...mapGetters([
            'canOperateOfficial',
            'canSetRelatedIssue',
            'canSetAnswerReply',
            'canSubmitAudit',
            'canAudit',
            'isAuditPending',
            'isClosed',
            'dontSaveQuestion',
            'isBug',
            'hasNotRelatedIssue'
        ])
    },
    methods: {
        hasClearIssue(query) {
            this.infoOkQuery = query;
            this.openConfirmWindow('clearRelatedIssue');
        },
        openConfirmWindow(name) {
            this.infoOpen = true;
            notAllowScroll();
            switch (name) {
                case 'clearRelatedIssue':
                    this.infoTip = this.showTips.notRelatedIssue;
                    this.operationType = 'clear-related-issue';
                    break;
                case 'notSetRelatedIssue':
                    this.infoTip = this.showTips.notRelatedIssue;
                    this.operationType = 'not-set-related-issue';
                    break;
                case 'withoutSaveQuestion':
                    this.infoTip = this.showTips.withoutSaveCategory;
                    this.operationType = 'without-save-category';
                    break;
                case 'withoutSaveReply':
                    this.infoTip = this.showTips.withoutSaveRely;
                    this.operationType = 'without-save-reply';
                    break;
                case 'audit-pass':
                    this.infoTip = '确认通过审核吗？';
                    this.operationType = 'audit-pass';
                    break;
            }
        },
        resetReply() {
            if (this.$refs.answer) {
                this.$refs.answer.resetAnswerReply();
            }
        },
        afterConfirmQuestionCategory(query) {
            if (this.$refs.officialIssue) {
                this.$refs.officialIssue.cancelNotRelated();
            }
            scrollToId('official-step-1');
            this.$refs.question.initQuestionCategory(query);
            this.resetReply();
        },
        clearRelatedIssue: throttle(function () {
            this.$store.dispatch('confirmQuestionCategory', {
                query: this.infoOkQuery,
                isClearList: true
            })
                .then(() => this.afterConfirmQuestionCategory(this.infoOkQuery));
        }),
        dontSetRelatedIssue: throttle(function () {
            this.$store.commit('setCheckedState', true);
            this.$store.dispatch('setOfficialRelatedIssue', {})
                .then(() => {
                    this.resetReply();
                    scrollToId('official-step-2');
                });
        }),
        ok() {
            switch (this.operationType) {
                case 'clear-related-issue': this.clearRelatedIssue();
                    break;
                case 'not-set-related-issue': this.dontSetRelatedIssue();
                    break;
                case 'without-save-category': this.$store.commit('setHasInputDetail', false);
                case 'without-save-reply': this.submitWithoutSave();
                    break;
                case 'audit-pass': this.auditPassReply();
                    break;
            }
            this.infoOpen = false;
            allowScroll();
        },
        cancel() {
            this.infoOpen = false;
            allowScroll();
            if (this.operationType === 'not-set-related-issue') {
                this.$refs.officialIssue.cancelNotRelated();
            }
        },
        submitToAudit: debounce(function () {
            // 1-提交审核 2-取消审核
            let type = this.isAuditPending ? 2 : 1;
            if (type === 1) {
                // 未指定审核人员
                if (!Object.keys(this.officialinfo.auditUserInfo).length) {
                    toast.info(this.showTips.withoutChooseAudit);
                    scrollToId('official-audit');
                    return;
                }

                // 问题状态更改未保存
                if (this.dontSaveQuestion) {
                    this.openConfirmWindow('withoutSaveQuestion');
                    return;
                }
                if (this.isBug) {
                    let questionDetail = this.$refs.question.getDetail();
                    if (questionDetail !== this.officialinfo.questionDetail) {
                        this.openConfirmWindow('withoutSaveQuestion');
                        return;
                    }
                }

                // issue关联未设置
                if (this.hasNotRelatedIssue) {
                    toast.info(this.showTips.withoutSetIssue);
                    scrollToId('official-step-2');
                    return;
                }

                // 若提交之前话术未保存，弹出提示
                let content = this.$refs.answer.getReply();
                if (content !== this.officialinfo.answerContent) {
                    this.openConfirmWindow('withoutSaveReply');
                    return;
                }
            }
            this.$store.dispatch('submitOfficialReply', type)
                .then(() => {
                    this.$store.commit('setHasInputDetail', false);
                    scrollToId('official-board');
                });
        }),
        submitWithoutSave() {
            this.$store.dispatch('submitOfficialReply', 1)
                .then(() => {
                    scrollToId('official-board');
                    this.$refs.question.initQuestionCategory(this.officialinfo);
                    this.resetReply();
                });
        },
        auditPassReply: throttle(function () {
            if (this.officialinfo.icafeUrl) {
                toast.info('审核结果同步中，请耐心等待！');
            }

            this.$store.dispatch('reviewOfficialReply', {type: 1})
                .then(() => scrollToId('official-board'));
        })
    }
};
</script>
